var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07143 0C0.478795 0 0 0.478795 0 1.07143V4.28571C0 4.87835 0.478795 5.35714 1.07143 5.35714C1.66406 5.35714 2.14286 4.87835 2.14286 4.28571V2.14286H4.28571C4.87835 2.14286 5.35714 1.66406 5.35714 1.07143C5.35714 0.478795 4.87835 0 4.28571 0H1.07143ZM2.14286 10.7143C2.14286 10.1217 1.66406 9.64286 1.07143 9.64286C0.478795 9.64286 0 10.1217 0 10.7143V13.9286C0 14.5212 0.478795 15 1.07143 15H4.28571C4.87835 15 5.35714 14.5212 5.35714 13.9286C5.35714 13.3359 4.87835 12.8571 4.28571 12.8571H2.14286V10.7143ZM10.7143 0C10.1217 0 9.64286 0.478795 9.64286 1.07143C9.64286 1.66406 10.1217 2.14286 10.7143 2.14286H12.8571V4.28571C12.8571 4.87835 13.3359 5.35714 13.9286 5.35714C14.5212 5.35714 15 4.87835 15 4.28571V1.07143C15 0.478795 14.5212 0 13.9286 0H10.7143ZM15 10.7143C15 10.1217 14.5212 9.64286 13.9286 9.64286C13.3359 9.64286 12.8571 10.1217 12.8571 10.7143V12.8571H10.7143C10.1217 12.8571 9.64286 13.3359 9.64286 13.9286C9.64286 14.5212 10.1217 15 10.7143 15H13.9286C14.5212 15 15 14.5212 15 13.9286V10.7143Z",
    fill: "#373939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType);
export default __webpack_public_path__ + "static/media/type.bd05e361ab771518d01a8680813992c2.svg";
export { ForwardRef as ReactComponent };